import useCartState from "src/core/checkout/hooks/useCartState";
import useOrderState from "src/core/checkout/hooks/useOrderState";
import useCartErrors from "../hooks/useCartErrors";
import useItemErrors from "../hooks/useItemErrors";

function AllowedToCheckout({children}) {
  const [cartState] = useCartState();
  const [orderState] = useOrderState();
  const [cartErrors] = useCartErrors();
  const [itemErrors] = useItemErrors();

  const cart = cartState.data;
  const hasItems = cart ? cart.hasItems() : false;

  const allowed =
    (!cartErrors || !cartErrors.length) &&
    (!itemErrors || !itemErrors.length) &&
    !orderState.loading &&
    !cartState.loading &&
    hasItems;

  return children({allowed});
}

export default AllowedToCheckout;
